// @ts-ignore
export const WebsiteUrl = "https://gdxsv.net";
export const DiscordUrl = "https://discord.gg/ktRw4JX";
export const GuideJaUrl = "https://gdoc.pub/doc/1o0ab6vRduUVefKC4GE7r2zhNfNomVKL8DdDQtx_ZBbA#?usp=sharing";
export const GuideEnUrl = "https://gdoc.pub/doc/1-wApGwlOh5sPLatshEp-xgzc5Q50w8j61LswsBdWZDM#?usp=sharing";
